import { useEffect, useState } from "react";
import { PackagePlus, Plus } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { KDV_DEFAULT, r2 } from "@/lib/pos";

// Hızlı satış sırasında kısa yeni ürün formu (barkod hazır gelebilir) → ürün oluşturulup sepete atılır
export function NewProductDialog({ initial, onClose, onCreated }) {
  const [np, setNp] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { setNp(initial ? { name: initial.name || "", brand: "", sale_price: "", quantity: "1", unit: "ADET", barcode: initial.barcode || "" } : null); }, [initial]);

  const save = async () => {
    const gross = Number(np.sale_price) || 0;
    if (!np.name.trim()) return toast.error("Ürün adı gerekli");
    if (gross <= 0) return toast.error("Satış fiyatı girin");
    const price = r2(gross / (1 + KDV_DEFAULT / 100));
    setSaving(true);
    try {
      const { data } = await api.post("/quick-sales/new-product", {
        name: np.name.trim(), brand: np.brand.trim(), price,
        unit: np.unit.trim() || "ADET", barcode: np.barcode.trim(),
        quantity: Number(np.quantity) || 0,
      });
      let r = null;
      try { const lk = await api.get(`/products/lookup?id=${encodeURIComponent(data.product.id)}&lite=true`); r = (lk.data || [])[0] || null; } catch { /* pos yoksa tek iskontodan türetilir */ }
      onCreated(data.product, r && r.sale_discount != null ? r.sale_discount : data.sale_discount, r);
    } catch (e) { toast.error(apiError(e)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={!!initial} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-[96vw] sm:max-w-md" data-testid="qs-new-product-dialog">
        <DialogHeader><DialogTitle className="font-head text-xl flex items-center gap-2"><PackagePlus className="h-5 w-5 text-primary" />Yeni Ürün Ekle</DialogTitle></DialogHeader>
        {np && (
          <>
            <div className="space-y-3">
              <div>
                <Label className="text-xs text-muted-foreground">Ürün Adı *</Label>
                <Input className="mt-1" value={np.name} onChange={(e) => setNp({ ...np, name: e.target.value })} data-testid="qs-np-name" autoFocus />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <Label className="text-xs text-muted-foreground">Marka</Label>
                  <Input className="mt-1" value={np.brand} onChange={(e) => setNp({ ...np, brand: e.target.value })} data-testid="qs-np-brand" />
                </div>
                <div>
                  <Label className="text-xs text-muted-foreground">Barkod (ops.)</Label>
                  <Input className="mt-1" value={np.barcode} onChange={(e) => setNp({ ...np, barcode: e.target.value })} data-testid="qs-np-barcode" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-3">
                <div>
                  <Label className="text-xs text-muted-foreground">Satış Fiyatı (KDV dahil) *</Label>
                  <Input className="mt-1 tabular-nums" type="number" value={np.sale_price} onChange={(e) => setNp({ ...np, sale_price: e.target.value })} data-testid="qs-np-price" />
                </div>
                <div>
                  <Label className="text-xs text-muted-foreground">Adet (stok)</Label>
                  <Input className="mt-1 tabular-nums" type="number" value={np.quantity} onChange={(e) => setNp({ ...np, quantity: e.target.value })} data-testid="qs-np-qty" />
                </div>
                <div>
                  <Label className="text-xs text-muted-foreground">Birim</Label>
                  <Input className="mt-1" value={np.unit} onChange={(e) => setNp({ ...np, unit: e.target.value })} data-testid="qs-np-unit" />
                </div>
              </div>
            </div>
            <div className="flex justify-end gap-2 pt-2">
              <Button variant="outline" onClick={onClose} data-testid="qs-np-cancel">Vazgeç</Button>
              <Button onClick={save} disabled={saving} data-testid="qs-np-save"><Plus className="h-4 w-4 mr-1.5" />{saving ? "Ekleniyor..." : "Ekle ve Sepete At"}</Button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
